import React from 'react';
import EmailPopup from '../EmailPopup';
import { EmailPopupCustomization } from 'src/hooks/usePopupVisibility';
import FormContent from 'molecules/EmailPopup/FormContent/FormContent';
import { useStaticQuery, graphql } from 'gatsby';
import { IStaticContentfulImages } from 'src/types/contentful';
import FailureMessage from '../FailureMessage';
import ThankYouMessage from './ThankYouMessage';

interface ProEmailPopupProps {
  customization?: EmailPopupCustomization;
}

const ProEmailPopup = ({ customization }: ProEmailPopupProps): JSX.Element => {
  const { image } = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      image: contentfulAsset(contentful_id: { eq: "226e11JoNIMOtlhM7ESw8" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1600)
      }
    }
  `);

  const renderContent = (blocked: boolean, customization?: EmailPopupCustomization) => (
    <FormContent
      formId='proEmailPopup'
      disabled={blocked}
      hideLegal
      headingText={customization?.title || '20+ lessons from real Mighty Pro Hosts'}
      supportingText={
        customization?.description ||
        'Delivered right to your inbox—they’ll help you get concrete about the possibilities for your business.'
      }
      buttonText='Send Me the Secrets'
      legalText='You’re opting into educational emails from Mighty. You can adjust your preferences and unsubscribe at any time.'
    />
  );

  return (
    <EmailPopup
      customization={customization}
      baseStorageKey='proEmailPopup'
      formId='b5c092d9-163f-47b1-9fc3-7a5b6c953a64'
      formWrapperId='proEmailPopup'
      formContent={renderContent}
      image={{
        image: image.gatsbyImageData,
        alt: 'Email popup image',
      }}
      successContent={(handleClose) => <ThankYouMessage onButtonClick={handleClose} />}
      failureContent={(handleClose) => <FailureMessage onButtonClick={handleClose} />}
    />
  );
};

export default ProEmailPopup;
